import { User } from "../types/profileTypes";


export const getCurrentUser = (): User | null => {
  try {
    // Try new auth structure first
    const authData = localStorage.getItem("auth-ts");
    if (authData) {
      const parsed = JSON.parse(authData);
      if (parsed.currentUser && parsed.currentUser.email) {
        return parsed.currentUser;
      }
    }
    
    // Fallback to legacy storage
    const storedUser = localStorage.getItem("currentUser");
    if (!storedUser) return null;

    const parsedUser: User = JSON.parse(storedUser);
    if (!parsedUser.email) {
      console.warn("Invalid user data in localStorage");
      return null;
    }

    return parsedUser;
  } catch (error) {
    console.error("Error parsing user data from localStorage:", error);
    return null;
  }
};

export const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const formatName = (name: string) => {
  return name
    ?.split("_")
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    ?.join(" ");
};

export const formatQueryArrayParam = (
  key: string,
  value: string | string[]
): string => {
  const valuesArray = Array.isArray(value) ? value : [value];
  return valuesArray
    .map((v) => `${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`)
    .join("&");
};

export const matchDynamicPath = (pattern: string, path: string): boolean => {
  const patternSegments = pattern?.split("/")?.filter(Boolean);
  const pathSegments = path?.split("/")?.filter(Boolean);

  if (patternSegments.length !== pathSegments.length) return false;

  return patternSegments.every((segment, index) => {
    return segment.startsWith(":") || segment === pathSegments[index];
  });
};
